<template>
  <a :href="route('damage.show', {
    customer: result.customer_id,
    damage: result.id,
})">
  <div class="result-card">
    <div class="flex-row align-items-center justify-content-between gap-sm">
      <div class="flex-row gap-sm align-items-center ">
        <div class="result-icon-wrapper">
          <BullhornIcon class="fill-primary icon-size-lg"></BullhornIcon>
        </div>

        <div class="grid">
          <p class="font-size-md mb-xxs color-primary">
            {{ result.damage_number }}
          </p>
          <LicensePlateComponent v-if="result.licenseplate" :inside-select="true" :license-plate="result.licenseplate"></LicensePlateComponent>
        </div>
      </div>
      <div class="">
        <Customer :customer-id="result.customer_id"></Customer>
      </div>
    </div>
  </div>
    </a>
</template>

<script>
import Customer from '../components/Customer.vue';
import LicensePlateComponent from '../../../LicensePlateComponent.vue';
export default {
  components: {
    LicensePlateComponent,
    Customer
  },
  name: "Damage",
  props: {
    result: {
      cause: {type: String, required: false},
      damage_number: {
        type: String,
        required: false,
      },
      licenseplate: {
        type: String,
        required: false,
      },
      customer_id: {
        type: Number,
        required: true,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.icon-wrapper {
  background-color: white;
  padding: $spacing-sm;
  border-radius: 9999px;

}
</style>
